import React, { memo } from 'react';
import { routes } from 'constants/config';
import Chart from 'components/Chart';
import colors from 'constants/colors';
import DataCardTitle from '../_shared/DataCard/Title';
import FilteredRequest from '../_shared/FilteredRequest';
import DateRangeFormat from '../_shared/DateRangeFormat';

const SearchesOverTimeChart = memo(({ i18n }) => (
  <FilteredRequest
    url={routes.INSIGHTS.SEARCH.SEARCHES_OVER_TIME}
    include={{
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }}
  >
    {({ data, error, params }) => (
      <div>
        <DataCardTitle
          title={i18n.searches.over_time.title}
          tooltip={
            params.start_date || params.end_date
              ? t('insights.searches.over_time.description_with_filter')
              : t('insights.searches.over_time.description')
          }
          subtitle={
            params.start_date || params.end_date ? (
              <DateRangeFormat
                start={params.start_date}
                end={params.end_date}
              />
            ) : (
              i18n.timeframes.last_6_months
            )
          }
        />
        {error && i18n.data_error}
        {!data && !error && i18n.loading}
        {!error && data && (
          <Chart
            config={{
              chart: {
                height: 240,
              },
              xAxis: {
                type: 'datetime',
                dateTimeLabelFormats: {
                  month: '%b',
                },
                // Make the data fill the entire axis
                minPadding: 0,
                maxPadding: 0,
              },
              yAxis: [
                // Left y-axis (search count):
                {
                  tickAmount: 2,
                  allowDecimals: false,
                },
                // Right y-axis (percentage):
                {
                  opposite: true,
                  // Hide this axis when its series is hidden
                  showEmpty: false,
                  // Since we’re displaying a percentage, force ticks at 0% and 100%
                  tickPositioner: () => [0, 100],
                  // ...but set the max to 105% so the 4px-wide line isn’t cut off
                  max: 105,
                  endOnTick: false,
                  labels: {
                    format: '{value}%',
                  },
                },
              ],
              plotOptions: {
                column: {
                  // Don’t stack columns
                  grouping: false,
                },
              },
              series: [
                // I would like to avoid manually parsing the dates to the JS
                // timestamps Highcharts expects, but can’t figure out how.
                {
                  name: i18n.searches.over_time.total_searches,
                  type: 'column',
                  yAxis: 0,
                  data: data.total_searches.map(point => [
                    Date.parse(point[0]),
                    point[1],
                  ]),
                  color: colors.YELLOW_DARK,
                },
                {
                  name: i18n.searches.over_time.searches_with_no_results,
                  type: 'column',
                  yAxis: 0,
                  data: data.searches_with_no_results.map(point => [
                    Date.parse(point[0]),
                    point[1],
                  ]),
                  color: colors.YELLOW_LIGHTER,
                },
                {
                  name: i18n.searches.over_time.no_results_percentages,
                  type: 'line',
                  yAxis: 1,
                  data: data.no_results_percentages.map(point => [
                    Date.parse(point[0]),
                    point[1],
                  ]),
                  color: colors.BLUE,
                  // Hide this series on page load (click to view)
                  visible: false,
                  tooltip: {
                    valueSuffix: '%',
                  },
                },
              ],
            }}
          />
        )}
      </div>
    )}
  </FilteredRequest>
));

export default SearchesOverTimeChart;
